import { ChevronLeft, ChevronRight } from '@untitled-ui/icons-react/build/cjs';
import React, { useEffect, useState } from 'react';
import ButtonCmp from 'src/components/ButtonCmp';

interface IPaginationProps {
    recordsPerPage: number;
    totalRecords: number;
    currentPage: number;
    handlePagination: (pageNumber: number) => void;
    parentClassName?: string;
    previousClassName?: string;
    nextClassName?: string;
    isShowPageDetail?: boolean;
}

const CustomPagination = ({
    recordsPerPage = 10,
    totalRecords = 0,
    currentPage = 1,
    previousClassName,
    nextClassName,
    parentClassName,
    handlePagination,
    isShowPageDetail = true,
}: IPaginationProps) => {
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [recordRange, setRecordRange] = useState({ start: 0, end: 0 });

    useEffect(() => {
        setTotalPageCount(Math.ceil(totalRecords / recordsPerPage));

        // Calculate the range of records being displayed
        const startRecord = totalRecords > 0 ? (currentPage - 1) * recordsPerPage + 1 : 0;
        const endRecord = Math.min(currentPage * recordsPerPage, totalRecords);

        setRecordRange({ start: startRecord, end: endRecord });
    }, [currentPage, totalRecords, recordsPerPage]);

    return (
        <>
            {totalPageCount > 1 ? (
                <div
                    className={`w-full flex justify-start items-center wal-pagination relative border-t border-utilityGray200 py-2.5 px-3 gap-x-3 ${parentClassName}`}
                    data-test-id="wal-QuotingDashboard-paginationNumber"
                >
                    <div className="flex items-center gap-1">
                        <ButtonCmp
                            disabled={currentPage === 1}
                            className={`rounded-md rounded-tr-none rounded-br-none bg-utilityGray100 text-textSecondary shadow-none !opacity-100 ${previousClassName}`}
                            size="square-xs"
                            onClick={() => {
                                handlePagination(currentPage - 1);
                            }}
                        >
                            <ChevronLeft className={`w-3 h-3 ${currentPage === 1 && 'opacity-40'}`} />
                        </ButtonCmp>

                        <ButtonCmp
                            disabled={currentPage === totalPageCount || currentPage > totalPageCount}
                            className={`rounded-md rounded-tl-none rounded-bl-none bg-utilityGray100 text-textSecondary shadow-none !opacity-100 ${nextClassName} `}
                            size="square-xs"
                            onClick={() => {
                                handlePagination(currentPage + 1);
                            }}
                        >
                            <ChevronRight className={`w-3 h-3 ${(currentPage === totalPageCount || currentPage > totalPageCount) && 'opacity-40'}`} />
                        </ButtonCmp>
                    </div>

                    {isShowPageDetail && <div className="text-textSecondary text-sm font-medium">{totalRecords > 0 ? `${recordRange.start}-${recordRange.end}` : '0'}</div>}
                </div>
            ) : (
                <> </>
            )}
        </>
    );
};

export default CustomPagination;
